import App from '../App'

import Vue from 'vue'
import Router from 'vue-router'
import store from '../vuex/state'
import transfer from '@/components/common/transfer' // 路由中转
import config from '@/conf'
import axios from 'axios';
import qs from 'qs';
import storage from '@/utils/storage'
import http from '@/utils/http'

Vue.use(Router)

// 页面信息对象
let sourceObj = {
  productindexType: 1,
  productindexName: '首页',
  searchType: 2,
  searchName: '搜索',
  listSearchType: 3,
  listSearchName: '搜索列表',
  articleType: 4,
  articleName: '文章页',
  activityType: 5,
  activityName: '落地页',
  getticketType: 6,
  getticketName: '券提取页',
  person_centerType: 7,
  person_centerName: '个人中心',
  productlistDiyType: 8,
  productlistDiyName: '商品列表DIY配色',
  productlistDisplayWindowType: 9,
  productlistDisplayWindowName: '商品列表橱窗',
  productlistDisplayWindowBrandType: 10,
  productlistDisplayWindowBrandName: '商品列表入驻品牌',
  detailsofthebneditionType: 11,
  detailsofthebneditionName: '商品详情',
  detailSkuType: 11,
  detailSkuName: '商品详情',
  detailCouponNullType: 11,
  detailCouponNullName: '商品详情',
  subordbneditionType: 12,
  subordbneditionName: '确认订单',
  paystatusinshopType: 13,
  paystatusinshopName: '支付状态',
  paystatusType: 13,
  paystatusName: '支付状态',
  orderdetailType: 14,
  orderdetailName: '订单详情',
  orderlistType: 15,
  orderlistName: '订单列表',
  exclusiveRecommendationType:16,
  exclusiveRecommendationName:'专属推荐',
  collectType:17,
  collectName:'商品收藏'
}
// 返回页面信息
let returnSourceObj = (name) => {
  if(name && sourceObj[name]){
    return sourceObj[name]
  }
  return name
}

// 设置本地页面信息
let setInfo = ( previousType, previousName, previousMainParam, previousOtherParam = []) => {
    previousType == 'remove' ? storage.remove('previousType', previousType) : previousType != 'self' ? storage.set('previousType', previousType) : ''
    previousName == 'remove' ? storage.remove('previousName', previousName) : previousName != 'self' ? storage.set('previousName', previousName) : ''
    previousMainParam == 'remove' ? storage.remove('previousMainParam', previousMainParam) : previousMainParam != 'self' ? storage.set('previousMainParam', previousMainParam) : ''
    previousOtherParam.length != 0 ? previousOtherParam == 'remove' ? storage.remove('previousOtherParam', previousOtherParam) : (previousOtherParam != 'self' ? storage.set('previousOtherParam', previousOtherParam) : '') : ''
}

// 返回类型和页面名
let returnPageOrTypeName = (name) => {
  if(name && sourceObj[name]){
    return sourceObj[name]
  }
  return
}

const router =  new Router({
  routes: [
    {
      path: '/',
      component: App, // 顶层路由
      children: [ // 二级路由
        // 地址为空跳转productIndex页面
        {
          path: '',
          redirect: '/productindex'
        },
        {
          path: '/productindex',
          name: 'productindex',
          component: resolve => require(['@/components/product/product_index'], resolve),
          meta: {
            title: '意礴定制商城',
          },
          children: [
          ]
        },
            {
              path: 'search',
              name: 'search',
              component: resolve => require(['@/components/index_children/search'], resolve),
              meta: {
                title: '首页_搜索'
              }
            },
            // 首页搜索结果列表
            {
              path: 'listSearch',
              name: 'listSearch',
              component: resolve => require(['@/components/index_children/list_search'], resolve),
              meta: {
                title: '搜索列表'
              }
            },
        // 中转路由
        {
          path: '/transfer',
          name: 'transfer',
          component: resolve => require(['@/components/common/transfer'], resolve), // 中转组件
        },
        {
          path: '/person_center',
          name: 'person_center',
          component: resolve => require(['@/components/personal_data/person_center'], resolve),
          meta: {
            title: '个人中心'
          },
        },
        {
          path:'/submitorder',
          name:'submitorder',
          component: resolve => require(['@/components/product/submit_order'], resolve),
          meta: {
            title: '提交订单'
          },
        },
        {
          path:'/submitordernocustom',
          name:'submitordernocustom',
          component: resolve => require(['@/components/product/submit_order_nocustom'], resolve),
          meta: {
            title: '提交订单'
          },
        },
        {
          path:'/subordbnedition',
          name:'subordbnedition',
          component: resolve => require(['@/components/product/subord_bnedition'], resolve),
          meta: {
            title: '提交订单'
          },
          children: [
            {
              path:'preferenceAcquisition',
              name:'preferenceAcquisition',
              component: resolve => require(['@/components/product/preference_acquisition'], resolve)
            }
          ]
        },
        {
          path:'/orderdetail',
          name:'orderdetail',
          component: resolve => require(['@/components/product/order_detail'], resolve),
          meta: {
            title: '订单详情'
          },
        },
        {
          path:'/debugpages',
          name:'debugpages',
          component: resolve => require(['@/components/debugpages/debugpages'], resolve),
          meta: {
            title: '确认订单地址'
          },
        },
        {
          path:'/commoditydetail',
          name:'commoditydetail',
          component: resolve => require(['@/components/product/commodity_detail'], resolve),
          meta: {
            title: '商品详情'
          },
        },
        {
          path:'/commoditydetailnocustom',
          name:'commoditydetailnocustom',
          component: resolve => require(['@/components/product/commodity_detail_nocustom'], resolve),
          meta: {
            title: '商品详情'
          },
        },
        {
          path:'/detailsofthebnedition',
          name:'detailsofthebnedition',
          component: resolve => require(['@/components/product/detailsofthe_bnedition'], resolve),
          meta: {
            title: '商品详情'
          },
          children: [
            {
              path:'',
              name:'detailCouponNull',
              component: resolve => require(['@/components/product_children/detail_coupon_null'], resolve),
              meta: {
                title: '商品详情'
              },
            },
            {
              path:'detailCoupon',
              name:'detailCoupon',
              component: resolve => require(['@/components/product_children/detail_coupon'], resolve),
              meta: {
                title: '商品详情'
              },
            },
            {
              path:'detailSku',
              name:'detailSku',
              component: resolve => require(['@/components/product_children/detail_sku'], resolve),
              meta: {
                title: '商品详情'
              },
            }
          ]
        },
        {
          path: '/addresslist',
          name: 'addresslist',
          component: resolve => require(['@/components/personal_data/addresslist'], resolve),
          props: true,
          meta: {
            title: '地址列表'
          },
        },
        {
          path: '/editaddress/:id',
          name: 'editaddress',
          component: resolve => require(['@/components/common/editaddress'], resolve),
          props: true,
          meta: {
            title: '编辑地址'
          },
        },
        {
          path:'/customexplain',
          name:'customexplain',
          component: resolve => require(['@/components/product/custom_explain'], resolve),
          meta: {
            title: '定制说明'
          },
        },
        {
          path:'/paystatus',
          name:'paystatus',
          component: resolve => require(['@/components/product/pay_status'], resolve),
          meta: {
            title: '支付状态'
          },
        },
        {
          path: '/paystatusinshop',
          name:'paystatusinshop',
          component: resolve => require(['@/components/product/pay_status_inshop'], resolve),
          meta: {
            title: '支付状态'
          }
        },
        {
          path:'/productlist',
          name:'productlist',
          component: resolve => require(['@/components/product/product_list'], resolve),
          props: true,
          meta: {
            title: '商品列表'
          }
        },
        {
          path:'/productlistnull',
          name:'productlistnull',
          component: resolve => require(['@/components/product/product_list_null'], resolve),
          props: true,
          meta: {
            title: '商品列表'
          }
        },
        {
          path: '/passportlist',
          name: 'passport_list',
          component: resolve => require(['@/components/personal_data/passport_list'], resolve),
          meta: {
            title: '报告列表'
          },
        },
        {
          path: '/passportdetail/:center/:uuid',
          name: 'passportdetail',
          component: resolve => require(['@/components/personal_data/passport_detail'], resolve),
          props: true,
        },
        {
          path: '/passportdetail',
          name: 'passport_detail',
          component: resolve => require(['@/components/personal_data/passport_detail'], resolve),
          meta: {
            title: '报告详情'
          },
        },
        {
          path: '/data_validation',
          name: 'data_validation',
          component: resolve => require(['@/components/personal_data/data_validation'], resolve),
          meta: {
            title: '足型数据确认'
          },
        },
        {
          path: '/footcomfir',
          name: 'footcomfir',
          component: resolve => require(['@/components/personal_data/footcomfir'], resolve),
          meta: {
            title: '确认报告'
          },
        },
        {
          path: '/personaldata',
          name: 'personal_data',
          component: resolve => require(['@/components/personal_data/personal_data'], resolve),
          meta: {
            title: '修改资料'
          },
        },
        {
          path: '/coupon/:type',
          name: 'coupon',
          component: resolve => require(['@/components/personal_data/coupon'], resolve),
          props: true,
          meta: {
            title: '优惠劵'
          },
        },
        {
          path: '/orderlist',
          name: 'orderlist',
          component: resolve => require(['@/components/order/orderlist'], resolve), // 订单列表
          meta: {
            title: '我的订单'
          }
        },
        {
          path: '/orderdelivery',
          name: 'orderdelivery',
          // component: orderdelivery,
          component: resolve => require(['@/components/order/order_delivery'], resolve), // 订单列表
          meta: {
            title: '订单跟踪'
          }
        },
        {
          path: '/verify',
          name: 'verify',
          component: resolve => require(['@/components/personal_data/verify'], resolve),
          meta: {
            title: '验证手机号'
          },
        },
        {
          path: '/coupondetail',
          name: 'coupon_detail',
          component: resolve => require(['@/components/personal_data/coupon_detail'], resolve),
          props: true,
          meta: {
            title: '优惠券详情'
          },
        },
        {
          path: '/coupondetailr',
          name: 'coupon_detail_r',
          component: resolve => require(['@/components/personal_data/coupon_detail_r'], resolve),
          props: true,
          meta: {
            title: '优惠券详情'
          },
        },
        {
          path: '/couponReceive',
          name: 'couponReceive',
          component: resolve => require(['@/components/personal_data/coupon_receive'], resolve),
          props: true,
          meta: {
            title: '领取优惠券'
          },
        },
        {
          path: '/orderevaluate',
          name: 'orderevaluate',
          component: resolve => require(['@/components/order/order_evaluate'], resolve), // 订单评价
          meta: {
            title: '订单评价'
          },
        },
        /*售后*/
        //售后生成
        {
          path: '/saleservicegenerate',
          name: 'saleservicegenerate',
          component: resolve => require(['@/components/saleservice/saleservice_generate'], resolve), // 售后生成
          meta: {
            title: '售后生成'
          },
        },
        //售后政策
        {
          path: '/saleservicepolicy',
          name: 'saleservicepolicy',
          component: resolve => require(['@/components/saleservice/saleservice_policy'], resolve), //售后政策
          meta: {
            title: '售后政策'
          },
        },
        // 售后列表
        {
          path: '/saleservicelist',
          name: 'saleservicelist',
          component: resolve => require(['@/components/saleservice/saleservice_list'], resolve), // 售后列表
          meta: {
            title: '售后列表'
          },
        },
        // 售后详情
        {
          path: '/saleserviceinfo',
          name: 'saleserviceinfo',
          component: resolve => require(['@/components/saleservice/saleservice_info'], resolve), // 售后详情
          meta: {
            title: '售后详情'
          },
        },

        //售后审核成功
        {
          path: '/saleservicesuccess',
          name: 'saleservicesuccess',
          component: resolve => require(['@/components/saleservice/saleservice_success'], resolve), //审核成功
          meta: {
            title: '审核成功'
          },
        },
        // 审核失败
        {
          path: '/saleservicefail',
          name: 'saleservicefail',
          component: resolve => require(['@/components/saleservice/saleservice_fail'], resolve), //审核失败
          meta: {
            title: '审核失败'
          },
        },
        //售后关闭
        {
          path: '/saleserviceclose',
          name: 'saleserviceclose',
          component: resolve => require(['@/components/saleservice/saleservice_close'], resolve), //售后关闭
          meta: {
            title: '售后关闭'
          },
        },

        //物流
        {
          path: '/saleservicelogistics',
          name: 'saleservicelogistics',
          component: resolve => require(['@/components/saleservice/saleservice_logistics'], resolve), //物流
          meta: {
            title: '物流信息'
          },
        },
        //工厂已收货
        {
          path: '/saleservicereceive',
          name: 'saleservicereceive',
          component: resolve => require(['@/components/saleservice/saleservice_receive'], resolve), //工厂已收货
        },
        //售后退款
        {
          path: '/saleservicerefund',
          name: 'saleservicerefund',
          component: resolve => require(['@/components/saleservice/saleservice_refund'], resolve), //退款
          meta: {
            title: '售后退款'
          },
        },
        //下拉加载测试
        {
          path: '/list',
          name: 'list',
          component: resolve => require(['@/components/product/list'], resolve), //下拉加载测试
        },
        //小编推荐
        {
          path: '/article',
          name: 'article',
          component: resolve => require(['@/components/product/article'], resolve),
          meta: {
            title: '小编推荐'
          },
        },
        // 活动专题页
        {
          path: '/activity',
          name: 'activity',
          component: resolve => require(['@/components/product/activity'], resolve),
          meta: {
            title: '活动专题页'
          },
        },
        {
          path: '/getticket',
          name: 'getticket',
          component: resolve => require(['@/components/product/getticket'], resolve),
          meta: {
            title: '券提取页'
          },
        },

        // 专题定制页
        {
          path: '/customArea',
          name: 'customArea',
          component: resolve => require(['@/components/product/custom_area'], resolve), //活动专题页
        },
        // 我的专属推荐页
        {
          path: '/exclusiveRecommendation',
          name: 'exclusiveRecommendation',
          component: resolve => require(['@/components/product/exclusive_recommendation'], resolve)
        },
        //指引页面
        // 失效页面
        {
          path: '/pageFailure',
          name: 'pageFailure',
          component: resolve => require(['@/components/common/page_failure'], resolve)
        },
        // 合伙人简介
        {
          path: '/partner',
          name: 'partner',
          component: resolve => require(['@/components/personal_data/partner'], resolve)
        },
        // 合伙人优惠券领取
        {
          path: '/partnerCoupon',
          name: 'partnerCoupon',
          component: resolve => require(['@/components/personal_data/partner_coupon'], resolve)
        },
         // 合伙人优惠券领取
         {
          path: '/getpartnercoupon',
          name: 'getpartnerCoupon',
          component: resolve => require(['@/components/personal_data/get_partner_coupon'], resolve)
        },
         // 商品收藏
         {
          path: '/collect',
          name: 'collect',
          component: resolve => require(['@/components/product/product_collect'], resolve)
        },
        // 活动 - 鞋款测评 投票
        {
          path: '/vote',
          name: 'vote',
          component: resolve => require(['@/components/activity/evaluation/vote'], resolve),
          meta: {
            title: '鞋款评测'
          },
        },
        // 活动 - 鞋款测评 抽奖 送券
        {
          path: '/wheel',
          name: 'wheel',
          component: resolve => require(['@/components/activity/evaluation/wheel'], resolve),
          meta: {
            title: '鞋款评测'
          },
        },
      ]
    },


  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

let getToken = (to) => {
  var referer;
  axios.post('/v1/user/token/get', {
    member_sign:to.query.membersign
  })
  .then(function (res) {
    if(res.data.code == 200){
      var token = res.data.data.token;
      //新获取的token  7天后过期
      const expiredTime = new Date().getTime()+25200000,
      epoqueToken = {"content":token, "expiredTime":expiredTime };
      localStorage.setItem("epoqueToken", JSON.stringify(epoqueToken));
      store.state.islogin=res.data.data.is_new;
      store.state.referer=res.data.data.referer;
      // console.log(res.data.data)
      // console.log(res.data.data.referer.indexOf('masterPartner=') != -1)
      if(res.data.data.referer == ''){
        referer = "/"
      }else if(res.data.data.referer.indexOf('masterPartner=') != -1){
        // referer = res.data.data.referer
        if(res.data.data.referer.indexOf('?masterPartner=') != -1){
          if(res.data.data.referer.indexOf('&') != -1){
            referer = res.data.data.referer.replace(/masterPartner=.*?\&/, '')
            // storage.set('masterPartnerUrl', res.data.data.referer.replace(/masterPartner=.*?\&/, ''))
          }else{
            referer = res.data.data.referer.split('?masterPartner=')[0]
            // storage.set('masterPartnerUrl', res.data.data.referer.split('?masterPartner=')[0])
          }
        }else if(res.data.data.referer.indexOf('&masterPartner=') != -1){
          var length = res.data.data.referer.split('&masterPartner=')[1].split('&').length
          if(length > 1){
            referer = res.data.data.referer.replace(/\&masterPartner=.*?(?=\&)/, '')
            // storage.set('masterPartnerUrl', res.data.data.referer.replace(/\&masterPartner=.*?(?=\&)/, ''))
          }else{
            referer = res.data.data.referer.split('&masterPartner=')[0]
            // storage.set('masterPartnerUrl', res.data.data.referer.split('&masterPartner=')[0])
          }
        }
      }else{
        referer = res.data.data.referer
      }
      storage.get('loginfirst') && (storage.remove('loginfirst'))
      //去掉重定向后的时间戳
      location.replace(location.protocol+'//'+location.host+'/#'+referer);
    }else{
      setTimeout(function(){
        var transferUrl = encodeURI(location.origin+"/@/transfer");
        var refererUrl = encodeURIComponent(to.fullPath);
        window.location.replace(`${config.routerapi}?transfer=${transferUrl}&referer=${refererUrl}`);
      },100)
    }

  })
  .catch(function (error) {
    console.log(error);
  });
}

// 返回字符串形式的数组或空
let returnArrStr = (arr = []) => {
  if(arr.length){
    return JSON.stringify(arr)
  }
  return
}
let currentOtherParam = []// 当前页剩余参
let previousOtherParam = []// 当前页剩余参
let a = 'null', b = 'null', c = 'null', d = 'null', e = 'null', f = 'null', g = 'null', h = 'null' // a = currentType, b = currentName, c = currentMainParam, d = currentOtherParam, evaluation = previousType, f = previousName, g = previousMainParam, h = previousOtherParam
// 传输页面信息, 有传参的使用传参，否则使用sessionStorage存储的
let transmitInformation = async (callback, a1,b1,c1,d1, e1, f1, g1, h1) => {
  let a,b,c,d, e, f, g, h
  if(a1){
    a1 != 'null' ? a = a1 : ''
  }else{
    a = storage.get('currentType')
  }
  if(b1){
    b1 != 'null' ? b = b1 : ''
  }else{
    b = storage.get('currentName')
  }
  if(c1){
    c1 != 'null' ? c = c1 : ''
  }else{
    c = storage.get('currentMainParam')
  }
  if(d1){
    d1 != 'null' ? d = d1 : ''
  }else{
    d = storage.get('currentOtherParam')
  }
  if(e1){
    e1 != 'null' ? e = e1 : ''
  }else{
    e = storage.get('previousType')
  }
  if(f1){
    f1 != 'null' ? f = f1 : ''
  }else{
    f = storage.get('previousName')
  }
  if(g1){
    g1 != 'null' ? g = g1 : ''
  }else{
    g = storage.get('previousMainParam')
  }
  if(h1){
    h1 != 'null' ? h = h1 : ''
  }else{
    h = storage.get('previousOtherParam')
  }
  let res = await http.post('/v1/user/op/log',{
    previous_type: e,
    previous_name: f,
    previous_main_param: g,
    previous_other_params: h,
    current_type: a,
    current_name: b,
    current_main_param: c,
    current_other_params: d,
  })
  callback && callback(res)
}

router.beforeEach((to, from, next) => {
  currentOtherParam = []// 当前页剩余参
  previousOtherParam = []// 当前页剩余参
  a = 'null'
  b = 'null'
  c = 'null'
  d = 'null'
  e = 'null'
  f = 'null'
  g = 'null'
  h = 'null'
  if(to.query.membersign){
    // 有membersign
    getToken(to, from, next)
  }else if(to.query.masterPartner){ // 从合伙人过来
    storage.set('masterPartnerUrl', to.query.masterPartner)
    storage.set('materNo', to.query.materNo)
    getToken(to, from, next)
  }else{
    // 无membersign
    if(localStorage.epoqueToken){
      // 有token
      try{
        JSON.parse(localStorage.epoqueToken).content
      }catch(err){
        window.localStorage.removeItem("epoqueToken");
        location.reload()
      }
      const currentTime = new Date().getTime(),
      epoqueToken = JSON.parse(localStorage.epoqueToken);
      if(epoqueToken.expiredTime-currentTime<0 && store.state.loginfirst){
        //删除token
        localStorage.removeItem("epoqueToken");
        //重新获取token跳授权
        setTimeout(function(){
          var transferUrl = encodeURI(location.origin+"/@/transfer");
          var refererUrl = encodeURIComponent(to.fullPath);
          window.location.replace(`${config.routerapi}?transfer=${transferUrl}&referer=${refererUrl}`);
        },100)
      }else{
        if(!from.name){
          if(storage.get('masterPartnerUrl')){
            currentOtherParam.push(`masterPartner: ${storage.get('masterPartnerUrl')}`)
          }
        }else{
          Object.entries(from.query).map((value, index) => {
            previousOtherParam.push(`${value[0]}: ${value[1]}`)
          })
          e = returnPageOrTypeName(`${from.name}Type`)
          f = returnPageOrTypeName(`${from.name}Name`)
        }
        Object.entries(to.query).map((value, index) => {
          currentOtherParam.push(`${value[0]}: ${value[1]}`)
        })
        a = returnPageOrTypeName(`${to.name}Type`)
        b = returnPageOrTypeName(`${to.name}Name`)
        if(to.path == '/productindex'){
          if(currentOtherParam[0] && currentOtherParam[0].match('masterPartner')){
            c = currentOtherParam[0]
          }
          if(previousOtherParam[0] && (previousOtherParam[0].match('id') || previousOtherParam[0].match('Id'))){
            g = previousOtherParam[0]
          }
          transmitInformation(() => {}, a, b, c, d, e, f, g, h)
        }else if(to.path == '/productlist'){
          if(to.query.source == 'diy'){
            a = 8
            b = '商品列表diy'
          }else if(to.query.brandId){
            a = 10
            b = '商品列表品牌'
            c = `brandNo: ${to.query.brandId}`
          }else if(to.query.source == 'displayWindow'){
            a = 9
            b = '商品列表橱窗'
            c = `shopwindowId: ${storage.get('shopwindowId')}`
          }
          transmitInformation(() => {}, a, b, c, d, e, f, g, h)
        }else if(to.path == '/detailsofthebnedition'){
          let tradeName = JSON.parse(storage.get('tradeName'))
          c = currentOtherParam[0]
          if(from.path != '/detailsofthebnedition/detailSku' && from.path != '/detailsofthebnedition/detailCoupon'){
            if(from.path == '/productlist'){
              if(from.query.source == 'diy'){
                e = 8
                f = '商品列表diy'
                setInfo( e, f, '', '')
              }else if(from.query.brandId){
                e = 10
                f = '商品列表品牌'
                g = `brandNo: ${from.query.brandId}`
                setInfo( e, f, g, '')
              }else if(from.query.source == 'displayWindow'){
                e = 9
                f = '商品列表橱窗'
                g = `shopwindowId: ${storage.get('shopwindowId')}`
                setInfo( e, f, g, '')
              }
            }else if(from.path == '/productindex'){
              e = 1
              f = '首页'
              setInfo( e, f, '', '')
            }else if(from.path == '/listSearch'){
              e = 3
              f = '搜索列表'
              if(storage.get('previousMainParam')){
                g = storage.get('previousMainParam')
              }
              if(storage.get('previousOtherParam')){
                h = storage.get('previousOtherParam')
              }
              setInfo( e, f, g, h)
            }else if(from.path == '/subordbnedition'){
              g = storage.get('previousMainParam')
            }else if(from.path == '/paystatusinshop'){
              g = storage.get('previousMainParam')
            }else if(from.path == '/orderdetail'){
              g = storage.get('previousMainParam')
            }else if(from.path == '/exclusiveRecommendation'){
              e = 16;
              f = '专属推荐'
              setInfo( e, f, g, h)
            }else if(from.path == '/collect'){
              e = 17;
              f = '商品收藏'
              setInfo( e, f, g, h)
            }
            transmitInformation(() => {}, a, b, c, d, e, f, g, h)
          }
        }else if(to.path == '/subordbnedition'){
          c =   `commodityId: ${to.query.commodityId}`
          // if(storage.get('currentMainParam')){
          //   c = storage.get('currentMainParam')
          // }
          // if(storage.get('currentOtherParam')){
          //   d = storage.get('currentOtherParam')
          // }

          if(storage.get('previousType')){
            e = storage.get('previousType')
          }
          if(storage.get('previousName')){
            f = storage.get('previousName')
          }
          if(storage.get('previousMainParam')){
            g = storage.get('previousMainParam')
          }
          if(storage.get('previousOtherParam')){
            h = storage.get('previousOtherParam')
          }
          transmitInformation(() => {}, a, b, c, d, e, f, g, h)
        }else if(to.path == '/paystatusinshop' || to.path == '/paystatus'){
          if((from.path == '/subordbnedition' || from.path == '/orderlist' || from.path == '/orderdetail') && store.state.normalPay == 1){
            if(to.path == '/paystatusinshop' || (to.query.paystatus && to.query.paystatus == 'true')){
              c = '支付成功'
            }else{
              c = '支付错误'
            }
            let dArr = []
            dArr.push(currentOtherParam[1])
            d = JSON.stringify(dArr)
            if(storage.get('previousType') && from.path == '/subordbnedition'){
              e = storage.get('previousType')
            }
            if(storage.get('previousName') && from.path == '/subordbnedition'){
              f = storage.get('previousName')
            }
            if(storage.get('previousMainParam') && from.path == '/subordbnedition'){
              g = storage.get('previousMainParam')
            }else{
              g = currentOtherParam[1]
            }
            if(storage.get('previousOtherParam') && from.path == '/subordbnedition'){
              h = storage.get('previousOtherParam')
            }
            store.state.normalPay = null
            transmitInformation(() => {}, a, b, c, d, e, f, g, h)
          }
        }else if(to.path == '/orderdetail'){
          if(from.path == '/subordbnedition' || from.path == '/orderlist'){
            c = '支付关闭'
            let dArr = []
            dArr.push(currentOtherParam[0])
            d = JSON.stringify(dArr)
            if(storage.get('previousType')){
              e = storage.get('previousType')
            }
            if(storage.get('previousName')){
              f = storage.get('previousName')
            }
            if(storage.get('previousMainParam')){
              g = storage.get('previousMainParam')
            }
            if(storage.get('previousOtherParam')){
              h = storage.get('previousOtherParam')
            }
            transmitInformation(() => {}, a, b, c, d, e, f, g, h)
          }
        }else if(to.path == '/article'){
          let shareTitle = store.state.detailApiDetails ? store.state.detailApiDetails.share_title : storage.get('activityShareTitle')
          c = `special_page:${to.query.specialId}`;
          transmitInformation(() => {}, a, b, c, d, e, f, g, h)
        }else if(to.path == '/activity'){
          let shareTitle = store.state.detailApiDetails ? store.state.detailApiDetails.share_title : storage.get('activityShareTitle')
          c = `special_page:${to.query.specialId}`
          transmitInformation(() => {}, a, b, c, d, e, f, g, h)
        }else if(to.path == '/getticket'){
          let shareTitle = store.state.detailApiDetails ? store.state.detailApiDetails.share_title : storage.get('activityShareTitle')
          c = `special_page:${to.query.specialId}`
          transmitInformation(() => {}, a, b, c, d, e, f, g, h)
        }else if(to.path =='/exclusiveRecommendation'){
          c = `uuid:${to.query.uuid}`
          transmitInformation(() => {}, a, b, c, d, e, f, g, h)
        }else if(to.path == '/collect'){
          transmitInformation(() => {}, a, b, c, d, e, f, g, h)
        }

        if(store.state.loginfirst && !storage.get('loginfirst')){
          let masterPartner,materNo;
          if(storage.get('masterPartnerUrl')){
            masterPartner = storage.get('masterPartnerUrl')
          }
          if(storage.get('materNo')){
            materNo = storage.get('materNo')
          }
          axios.post('/v1/user/update/status', qs.stringify({
            masterPartner: masterPartner,
            materNo: materNo,
            // ip: returnCitySN["cip"]
          })).then(function(res){
            if( res.data.code && res.data.code==200 ){
              store.state.loginfirst = false;
              storage.set('loginfirst', true)
              masterPartner = storage.remove('masterPartnerUrl')
              materNo = storage.remove('materNo')
              next()
            }else{
              setTimeout(function(){
                var transferUrl = encodeURI(location.origin+"/@/transfer");
                var refererUrl = encodeURIComponent(to.fullPath);
                window.location.replace(`${config.routerapi}?transfer=${transferUrl}&referer=${refererUrl}`);
              },100)
            }
          })
        }else{
          if(storage.get('masterPartnerUrl')){
              setTimeout(function(){
                var transferUrl = encodeURI(location.origin+"/@/transfer");
                var refererUrl = encodeURIComponent(to.fullPath);
                window.location.replace(`${config.routerapi}?transfer=${transferUrl}&referer=${refererUrl}`);
              },100)
          }else{
            next()
          }
        }
      }
    }else{
      // 无token
      setTimeout(function(){
        var transferUrl = encodeURI(location.origin+"/@/transfer");
        var refererUrl = encodeURIComponent(to.fullPath);
        window.location.replace(`${config.routerapi}?transfer=${transferUrl}&referer=${refererUrl}`);
      },100)
    }
  }
})

router.afterEach(route => {
  // 从路由的元信息中获取 title 属性
  // Vue.nextTick(() => {
  //   sensors.quick("autoTrackSinglePage");
  // });
  if (route.meta.title) {
    document.title = route.meta.title
    // 如果是 iOS 设备，则使用如下 hack 的写法实现页面标题的更新
    if (navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
      const hackIframe = document.createElement('iframe')
      hackIframe.style.display = 'none'
      // hackIframe.src = '/robots.txt?r=' + Math.random()
      document.body.appendChild(hackIframe)
      setTimeout(_ => {
        document.body.removeChild(hackIframe)
      }, 300)
    }
  }
})

export default router





// WEBPACK FOOTER //
// ./src/router/index.js